<div class="left-section z-10">
  <lib-ffd-notes-list
    [items]="noteGroups()"
    [searchTerm]="searchTerm()"
    (searchTermChange)="onSearch($event)"
    [isLoading]="isLoading()"
    [selectedNoteId]="selectedNoteId()"
    [infiniteScrollLoading]="infiniteScrollLoading()"
    (endReached)="onLoadMore()"
    (noteClick)="onNoteClick($event)"
    (noteEdit)="onNoteEditClick($event)"
    (noteDelete)="onDeleteNote($event)"
  />
</div>
<div class="right-section flex flex-col overflow-hidden">
  @if (isLoading()) {
    <div class="flex flex-grow flex-col overflow-hidden bg-background-white pt-6">
      <div class="flex flex-col gap-4 px-10 py-6">
        <div
          class="flex animate-pulse flex-row items-center justify-between border-0 border-b border-solid border-background-disabled py-3"
        >
          <div class="h-10 w-[258px] animate-pulse rounded-3xl bg-background-light-grey"></div>
          <div class="h-5 w-[120px] animate-pulse rounded-3xl bg-background-light-grey"></div>
          <div class="flex flex-row gap-4">
            <div class="h-10 w-[160px] animate-pulse rounded-3xl bg-background-light-grey"></div>
            <div class="h-10 w-10 animate-pulse rounded-3xl bg-background-light-grey"></div>
          </div>
        </div>
        @for (item of loadingSkeletons(); track $index) {
          <div class="h-4 w-full animate-pulse rounded-3xl bg-background-light-grey"></div>
        }
      </div>
    </div>
  } @else if (activeNoteGroup()) {
    <div class="flex flex-grow flex-col overflow-hidden bg-background-white pt-6">
      <lib-ffd-notes-detail
        [activeNoteItem]="activeNote()"
        [searchTerm]="searchTerm()"
        [selectedNoteId]="selectedNoteId()"
        [editedNoteId]="editedNoteId()"
        [isNoteSaving]="isNoteSaving()"
        [isNoteSaved]="isNoteSaved()"
        (noteClick)="onNoteClick($event)"
        (noteEdit)="onNoteEditClick($event)"
        (noteSave)="onNoteSave($event)"
        (deleteNote)="onDeleteNote($event)"
      ></lib-ffd-notes-detail>
    </div>
  }
</div>
